import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { ProductEventProperties } from './types';

export const trackProductAdded = (properties: ProductEventProperties) =>
    sendAnalyticsEvent<ProductEventProperties>('Product Added', properties);
